import { Component, OnInit, Input } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { ApiService } from '../service/api.service';
import { UtilService } from '../service/util.service';
import { Constants } from '../constants/constants';
import { ToastService } from '../service/toast.service';

@Component({
  selector: 'developer-access',
  templateUrl: './developer-access.component.html',
  styleUrls: ['./developer-access.component.scss']
})
export class DeveloperAccessComponent implements OnInit {

  @Input() modalId: string = "apiAccess";
  @Input() modalOpenButtonId: string = "openDeveloperAccess";
  @Input() modalCloseButtonId: string = "closeDeveloperAccess";

  apiKeys: any = [];
  secretkeyVisibility: Array<boolean> = new Array();
  resetIndexSelected;
  
  constructor(private authService: AuthenticationService, public apiService: ApiService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
  }

  openDeveloperAccess() {
    if (this.authService.loggedInUser == null)
      return;
    this.getApiKey();
    // document.getElementById("openDeveloperAccess").click();
  }
  
  getApiKey() {
    this.utilService.showSpinner();
    this.apiService.getApiKey().then((data) => {
      this.utilService.hideSpinner();
      this.apiKeys = data;
      console.log("api key data::", this.apiKeys);
      this.initSecretVisibilityIndex();
      document.getElementById(this.modalOpenButtonId).click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getApiKey();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initSecretVisibilityIndex() {
    this.secretkeyVisibility = [];
    if (this.apiKeys != null && this.apiKeys.length > 0) {
      this.apiKeys.forEach(element => {
        this.secretkeyVisibility.push(false);
      });
    }
  }

  onClickShowSecretKey(index: number) {
    this.secretkeyVisibility[index] = !this.secretkeyVisibility[index];
  }

}
